import Loader from 'components/Loader'
import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'

const ReporteIntegraciones = lazy(async () => import('./ReporteIntegraciones/ReporteIntegraciones'))
const ConfiguracionSobretasa = lazy(async () => import('./ConfiguracionSobretasa'))

interface IntegracionesWORouteProps {
  match: {
    url: string
  }
}

const IntegracionesWO = ({ match }: IntegracionesWORouteProps): JSX.Element => {
  return (
    <div className="app-wrapper">
      <Switch>
        <Suspense fallback={<Loader />}>
          <Route path={`${match.url}/reporte_integraciones`} component={ReporteIntegraciones} />
          <Route path={`${match.url}/configuracion_sobretasa`} component={ConfiguracionSobretasa} />
        </Suspense>
      </Switch>
    </div>
  )
}

export default IntegracionesWO
